/** @jsxImportSource react */
import React from 'react'
import { useThemeLanguage } from '@/contexts/ThemeLanguageContext'

const globeIcon = (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width={20} height={20} aria-hidden>
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" />
    <ellipse
      cx="12"
      cy="12"
      rx="10"
      ry="4"
      stroke="currentColor"
      strokeWidth="1.5"
      transform="rotate(90 12 12)"
    />
    <path d="M2 12H22" stroke="currentColor" strokeWidth="1.5" />
  </svg>
)

type WorkspaceLangButtonProps = {
  ariaLabel?: string
  testId?: string
}

export function WorkspaceLangButton({
  ariaLabel,
  testId = 'workspace-lang-selector',
}: WorkspaceLangButtonProps) {
  const { lang, setLang, t } = useThemeLanguage()

  return (
    <button
      type="button"
      className="recruiter-lang-selector"
      data-testid={testId}
      onClick={() => setLang(lang === 'es' ? 'en' : 'es')}
      title={lang === 'es' ? t('candidate.switchToEnglish') : t('candidate.switchToSpanish')}
      aria-label={ariaLabel ?? t('layout.changeLanguage')}
    >
      {globeIcon}
    </button>
  )
}
